// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension="
// @generated from file pages/v2/page.proto (package pages.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from '@bufbuild/protobuf/codegenv2'
import { fileDesc, messageDesc, serviceDesc } from '@bufbuild/protobuf/codegenv2'
import type { VersionIncrement } from '../../asset/v1/asset_pb'
import { file_asset_v1_asset } from '../../asset/v1/asset_pb'
import { file_common_v1_annotations } from '../../common/v1/annotations_pb'
import type { PaginationArguments, PaginationPageInfo } from '../../common/v1/pagination_pb'
import { file_common_v1_pagination } from '../../common/v1/pagination_pb'
import type { Creator } from '../../common/v1/types_pb'
import { file_common_v1_types } from '../../common/v1/types_pb'
import { file_google_api_annotations } from '../../google/api/annotations_pb'
import type { FieldMask, Timestamp } from '@bufbuild/protobuf/wkt'
import {
  file_google_protobuf_field_mask,
  file_google_protobuf_struct,
  file_google_protobuf_timestamp
} from '@bufbuild/protobuf/wkt'
import type { JsonObject, Message } from '@bufbuild/protobuf'

/**
 * Describes the file pages/v2/page.proto.
 */
export const file_pages_v2_page: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_asset_v1_asset,
      file_common_v1_annotations,
      file_common_v1_pagination,
      file_common_v1_types,
      file_google_api_annotations,
      file_google_protobuf_field_mask,
      file_google_protobuf_struct,
      file_google_protobuf_timestamp
    ]
  )

/**
 * @generated from message pages.v2.Template
 */
export type Template = Message<'pages.v2.Template'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 14;
   */
  version: string

  /**
   * @generated from field: string page_id = 2;
   */
  pageId: string

  /**
   * @generated from field: string org_id = 3;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string

  /**
   * @generated from field: string state = 5;
   */
  state: string

  /**
   * @generated from field: string visibility = 13;
   */
  visibility: string

  /**
   * @generated from field: common.v1.Creator creator = 6;
   */
  creator?: Creator

  /**
   * @generated from field: string name = 7;
   */
  name: string

  /**
   * @generated from field: optional string description = 8;
   */
  description?: string

  /**
   * @generated from field: string folder_path = 9;
   */
  folderPath: string

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp
}

/**
 * Describes the message pages.v2.Template.
 * Use `create(TemplateSchema)` to create a new message.
 */
export const TemplateSchema: GenMessage<Template> = /*@__PURE__*/ messageDesc(file_pages_v2_page, 0)

/**
 * @generated from message pages.v2.Component
 */
export type Component = Message<'pages.v2.Component'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string type_uri = 2;
   */
  typeUri: string

  /**
   * @generated from field: optional string asset_id = 5;
   */
  assetId?: string

  /**
   * @generated from field: optional string asset_version = 6;
   */
  assetVersion?: string

  /**
   * @generated from field: google.protobuf.Struct style = 3;
   */
  style?: JsonObject

  /**
   * @generated from field: repeated pages.v2.Component children = 4;
   */
  children: Component[]
}

/**
 * Describes the message pages.v2.Component.
 * Use `create(ComponentSchema)` to create a new message.
 */
export const ComponentSchema: GenMessage<Component> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 1)

/**
 * @generated from message pages.v2.Page
 */
export type Page = Message<'pages.v2.Page'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 16;
   */
  version: string

  /**
   * @generated from field: string org_id = 3;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string

  /**
   * @generated from field: optional string template_id = 2;
   */
  templateId?: string

  /**
   * @generated from field: optional string brand_kit_id = 5;
   */
  brandKitId?: string

  /**
   * @generated from field: string state = 6;
   */
  state: string

  /**
   * @generated from field: common.v1.Creator creator = 7;
   */
  creator?: Creator

  /**
   * @generated from field: string name = 8;
   */
  name: string

  /**
   * @generated from field: string folder_path = 9;
   */
  folderPath: string

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Struct theme = 11;
   */
  theme?: JsonObject

  /**
   * @generated from field: google.protobuf.Struct config = 12;
   */
  config?: JsonObject

  /**
   * @generated from field: repeated pages.v2.Component components = 13;
   */
  components: Component[]

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 14;
   */
  createdAt?: Timestamp

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp
}

/**
 * Describes the message pages.v2.Page.
 * Use `create(PageSchema)` to create a new message.
 */
export const PageSchema: GenMessage<Page> = /*@__PURE__*/ messageDesc(file_pages_v2_page, 2)

/**
 * @generated from message pages.v2.CreateTemplateRequest
 */
export type CreateTemplateRequest = Message<'pages.v2.CreateTemplateRequest'> & {
  /**
   * @generated from field: string page_id = 1;
   */
  pageId: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string

  /**
   * @generated from field: string visibility = 8;
   */
  visibility: string

  /**
   * @generated from field: string name = 4;
   */
  name: string

  /**
   * @generated from field: optional string description = 5;
   */
  description?: string

  /**
   * @generated from field: string folder_path = 6;
   */
  folderPath: string

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[]
}

/**
 * Describes the message pages.v2.CreateTemplateRequest.
 * Use `create(CreateTemplateRequestSchema)` to create a new message.
 */
export const CreateTemplateRequestSchema: GenMessage<CreateTemplateRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 3)

/**
 * @generated from message pages.v2.CreateTemplateResponse
 */
export type CreateTemplateResponse = Message<'pages.v2.CreateTemplateResponse'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template
}

/**
 * Describes the message pages.v2.CreateTemplateResponse.
 * Use `create(CreateTemplateResponseSchema)` to create a new message.
 */
export const CreateTemplateResponseSchema: GenMessage<CreateTemplateResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 4)

/**
 * @generated from message pages.v2.CreateTemplateVersionRequest
 */
export type CreateTemplateVersionRequest = Message<'pages.v2.CreateTemplateVersionRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2 [deprecated = true];
   * @deprecated
   */
  version: string

  /**
   * @generated from field: asset.v1.VersionIncrement increment = 4;
   */
  increment: VersionIncrement

  /**
   * @generated from field: string base_version = 3;
   */
  baseVersion: string
}

/**
 * Describes the message pages.v2.CreateTemplateVersionRequest.
 * Use `create(CreateTemplateVersionRequestSchema)` to create a new message.
 */
export const CreateTemplateVersionRequestSchema: GenMessage<CreateTemplateVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 5)

/**
 * @generated from message pages.v2.CreateTemplateVersionResponse
 */
export type CreateTemplateVersionResponse = Message<'pages.v2.CreateTemplateVersionResponse'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template
}

/**
 * Describes the message pages.v2.CreateTemplateVersionResponse.
 * Use `create(CreateTemplateVersionResponseSchema)` to create a new message.
 */
export const CreateTemplateVersionResponseSchema: GenMessage<CreateTemplateVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 6)

/**
 * @generated from message pages.v2.PublishTemplateVersionRequest
 */
export type PublishTemplateVersionRequest = Message<'pages.v2.PublishTemplateVersionRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string

  /**
   * @generated from field: string visibility = 3;
   */
  visibility: string
}

/**
 * Describes the message pages.v2.PublishTemplateVersionRequest.
 * Use `create(PublishTemplateVersionRequestSchema)` to create a new message.
 */
export const PublishTemplateVersionRequestSchema: GenMessage<PublishTemplateVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 7)

/**
 * @generated from message pages.v2.PublishTemplateVersionResponse
 */
export type PublishTemplateVersionResponse = Message<'pages.v2.PublishTemplateVersionResponse'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template
}

/**
 * Describes the message pages.v2.PublishTemplateVersionResponse.
 * Use `create(PublishTemplateVersionResponseSchema)` to create a new message.
 */
export const PublishTemplateVersionResponseSchema: GenMessage<PublishTemplateVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 8)

/**
 * @generated from message pages.v2.CreatePageVersionRequest
 */
export type CreatePageVersionRequest = Message<'pages.v2.CreatePageVersionRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2 [deprecated = true];
   * @deprecated
   */
  version: string

  /**
   * @generated from field: asset.v1.VersionIncrement increment = 4;
   */
  increment: VersionIncrement

  /**
   * @generated from field: string base_version = 3;
   */
  baseVersion: string
}

/**
 * Describes the message pages.v2.CreatePageVersionRequest.
 * Use `create(CreatePageVersionRequestSchema)` to create a new message.
 */
export const CreatePageVersionRequestSchema: GenMessage<CreatePageVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 9)

/**
 * @generated from message pages.v2.CreatePageVersionResponse
 */
export type CreatePageVersionResponse = Message<'pages.v2.CreatePageVersionResponse'> & {
  /**
   * @generated from field: pages.v2.Page Page = 1;
   */
  Page?: Page
}

/**
 * Describes the message pages.v2.CreatePageVersionResponse.
 * Use `create(CreatePageVersionResponseSchema)` to create a new message.
 */
export const CreatePageVersionResponseSchema: GenMessage<CreatePageVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 10)

/**
 * @generated from message pages.v2.PublishPageVersionRequest
 */
export type PublishPageVersionRequest = Message<'pages.v2.PublishPageVersionRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message pages.v2.PublishPageVersionRequest.
 * Use `create(PublishPageVersionRequestSchema)` to create a new message.
 */
export const PublishPageVersionRequestSchema: GenMessage<PublishPageVersionRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 11)

/**
 * @generated from message pages.v2.PublishPageVersionResponse
 */
export type PublishPageVersionResponse = Message<'pages.v2.PublishPageVersionResponse'> & {
  /**
   * @generated from field: pages.v2.Page Page = 1;
   */
  Page?: Page
}

/**
 * Describes the message pages.v2.PublishPageVersionResponse.
 * Use `create(PublishPageVersionResponseSchema)` to create a new message.
 */
export const PublishPageVersionResponseSchema: GenMessage<PublishPageVersionResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 12)

/**
 * @generated from message pages.v2.ListTemplatesRequest
 */
export type ListTemplatesRequest = Message<'pages.v2.ListTemplatesRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string

  /**
   * @generated from field: optional string folder_path = 3;
   */
  folderPath?: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: string name_prefix = 6;
   */
  namePrefix: string

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[]

  /**
   * @generated from field: repeated string visibilities = 9;
   */
  visibilities: string[]

  /**
   * @generated from field: common.v1.PaginationArguments pagination = 4;
   */
  pagination?: PaginationArguments
}

/**
 * Describes the message pages.v2.ListTemplatesRequest.
 * Use `create(ListTemplatesRequestSchema)` to create a new message.
 */
export const ListTemplatesRequestSchema: GenMessage<ListTemplatesRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 13)

/**
 * @generated from message pages.v2.ListTemplatesResponse
 */
export type ListTemplatesResponse = Message<'pages.v2.ListTemplatesResponse'> & {
  /**
   * @generated from field: repeated pages.v2.Template templates = 1;
   */
  templates: Template[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message pages.v2.ListTemplatesResponse.
 * Use `create(ListTemplatesResponseSchema)` to create a new message.
 */
export const ListTemplatesResponseSchema: GenMessage<ListTemplatesResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 14)

/**
 * @generated from message pages.v2.GetTemplateRequest
 */
export type GetTemplateRequest = Message<'pages.v2.GetTemplateRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message pages.v2.GetTemplateRequest.
 * Use `create(GetTemplateRequestSchema)` to create a new message.
 */
export const GetTemplateRequestSchema: GenMessage<GetTemplateRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 15)

/**
 * @generated from message pages.v2.GetTemplateResponse
 */
export type GetTemplateResponse = Message<'pages.v2.GetTemplateResponse'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template
}

/**
 * Describes the message pages.v2.GetTemplateResponse.
 * Use `create(GetTemplateResponseSchema)` to create a new message.
 */
export const GetTemplateResponseSchema: GenMessage<GetTemplateResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 16)

/**
 * @generated from message pages.v2.UpdateTemplateRequest
 */
export type UpdateTemplateRequest = Message<'pages.v2.UpdateTemplateRequest'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template

  /**
   * @generated from field: google.protobuf.FieldMask mask = 2;
   */
  mask?: FieldMask
}

/**
 * Describes the message pages.v2.UpdateTemplateRequest.
 * Use `create(UpdateTemplateRequestSchema)` to create a new message.
 */
export const UpdateTemplateRequestSchema: GenMessage<UpdateTemplateRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 17)

/**
 * @generated from message pages.v2.UpdateTemplateResponse
 */
export type UpdateTemplateResponse = Message<'pages.v2.UpdateTemplateResponse'> & {
  /**
   * @generated from field: pages.v2.Template template = 1;
   */
  template?: Template
}

/**
 * Describes the message pages.v2.UpdateTemplateResponse.
 * Use `create(UpdateTemplateResponseSchema)` to create a new message.
 */
export const UpdateTemplateResponseSchema: GenMessage<UpdateTemplateResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 18)

/**
 * @generated from message pages.v2.DeleteTemplateRequest
 */
export type DeleteTemplateRequest = Message<'pages.v2.DeleteTemplateRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string
}

/**
 * Describes the message pages.v2.DeleteTemplateRequest.
 * Use `create(DeleteTemplateRequestSchema)` to create a new message.
 */
export const DeleteTemplateRequestSchema: GenMessage<DeleteTemplateRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 19)

/**
 * @generated from message pages.v2.DeleteTemplateResponse
 */
export type DeleteTemplateResponse = Message<'pages.v2.DeleteTemplateResponse'> & {}

/**
 * Describes the message pages.v2.DeleteTemplateResponse.
 * Use `create(DeleteTemplateResponseSchema)` to create a new message.
 */
export const DeleteTemplateResponseSchema: GenMessage<DeleteTemplateResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 20)

/**
 * @generated from message pages.v2.CreatePageRequest
 */
export type CreatePageRequest = Message<'pages.v2.CreatePageRequest'> & {
  /**
   * @generated from field: optional string brand_kit_id = 1;
   */
  brandKitId?: string

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 3;
   */
  workspaceId: string

  /**
   * @generated from field: string name = 4;
   */
  name: string

  /**
   * @generated from field: string folder_path = 5;
   */
  folderPath: string

  /**
   * @generated from field: repeated string tags = 6;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Struct theme = 7;
   */
  theme?: JsonObject

  /**
   * @generated from field: repeated pages.v2.Component components = 8;
   */
  components: Component[]

  /**
   * @generated from field: google.protobuf.Struct config = 9;
   */
  config?: JsonObject

  /**
   * @generated from field: google.protobuf.Struct data = 10;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.CreatePageRequest.
 * Use `create(CreatePageRequestSchema)` to create a new message.
 */
export const CreatePageRequestSchema: GenMessage<CreatePageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 21)

/**
 * @generated from message pages.v2.CreatePageResponse
 */
export type CreatePageResponse = Message<'pages.v2.CreatePageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page
}

/**
 * Describes the message pages.v2.CreatePageResponse.
 * Use `create(CreatePageResponseSchema)` to create a new message.
 */
export const CreatePageResponseSchema: GenMessage<CreatePageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 22)

/**
 * @generated from message pages.v2.CreatePageFromTemplateRequest
 */
export type CreatePageFromTemplateRequest = Message<'pages.v2.CreatePageFromTemplateRequest'> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string

  /**
   * @generated from field: string template_version = 9;
   */
  templateVersion: string

  /**
   * @generated from field: optional string brand_kit_id = 2;
   */
  brandKitId?: string

  /**
   * @generated from field: string org_id = 3;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 4;
   */
  workspaceId: string

  /**
   * @generated from field: string name = 5;
   */
  name: string

  /**
   * @generated from field: string folder_path = 6;
   */
  folderPath: string

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[]

  /**
   * @generated from field: google.protobuf.Struct config = 8;
   */
  config?: JsonObject
}

/**
 * Describes the message pages.v2.CreatePageFromTemplateRequest.
 * Use `create(CreatePageFromTemplateRequestSchema)` to create a new message.
 */
export const CreatePageFromTemplateRequestSchema: GenMessage<CreatePageFromTemplateRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 23)

/**
 * @generated from message pages.v2.CreatePageFromTemplateResponse
 */
export type CreatePageFromTemplateResponse = Message<'pages.v2.CreatePageFromTemplateResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page
}

/**
 * Describes the message pages.v2.CreatePageFromTemplateResponse.
 * Use `create(CreatePageFromTemplateResponseSchema)` to create a new message.
 */
export const CreatePageFromTemplateResponseSchema: GenMessage<CreatePageFromTemplateResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 24)

/**
 * @generated from message pages.v2.ListPagesRequest
 */
export type ListPagesRequest = Message<'pages.v2.ListPagesRequest'> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string

  /**
   * @generated from field: optional string folder_path = 3;
   */
  folderPath?: string

  /**
   * @generated from field: string creator_id = 5;
   */
  creatorId: string

  /**
   * @generated from field: string name_prefix = 6;
   */
  namePrefix: string

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[]

  /**
   * @generated from field: common.v1.PaginationArguments pagination = 4;
   */
  pagination?: PaginationArguments
}

/**
 * Describes the message pages.v2.ListPagesRequest.
 * Use `create(ListPagesRequestSchema)` to create a new message.
 */
export const ListPagesRequestSchema: GenMessage<ListPagesRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 25)

/**
 * @generated from message pages.v2.ListPagesResponse
 */
export type ListPagesResponse = Message<'pages.v2.ListPagesResponse'> & {
  /**
   * @generated from field: repeated pages.v2.Page pages = 1;
   */
  pages: Page[]

  /**
   * @generated from field: common.v1.PaginationPageInfo page_info = 2;
   */
  pageInfo?: PaginationPageInfo
}

/**
 * Describes the message pages.v2.ListPagesResponse.
 * Use `create(ListPagesResponseSchema)` to create a new message.
 */
export const ListPagesResponseSchema: GenMessage<ListPagesResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 26)

/**
 * @generated from message pages.v2.GetPageRequest
 */
export type GetPageRequest = Message<'pages.v2.GetPageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message pages.v2.GetPageRequest.
 * Use `create(GetPageRequestSchema)` to create a new message.
 */
export const GetPageRequestSchema: GenMessage<GetPageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 27)

/**
 * @generated from message pages.v2.GetPageResponse
 */
export type GetPageResponse = Message<'pages.v2.GetPageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page
}

/**
 * Describes the message pages.v2.GetPageResponse.
 * Use `create(GetPageResponseSchema)` to create a new message.
 */
export const GetPageResponseSchema: GenMessage<GetPageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 28)

/**
 * @generated from message pages.v2.UpdatePageRequest
 */
export type UpdatePageRequest = Message<'pages.v2.UpdatePageRequest'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page

  /**
   * @generated from field: google.protobuf.FieldMask mask = 2;
   */
  mask?: FieldMask
}

/**
 * Describes the message pages.v2.UpdatePageRequest.
 * Use `create(UpdatePageRequestSchema)` to create a new message.
 */
export const UpdatePageRequestSchema: GenMessage<UpdatePageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 29)

/**
 * @generated from message pages.v2.UpdatePageResponse
 */
export type UpdatePageResponse = Message<'pages.v2.UpdatePageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page
}

/**
 * Describes the message pages.v2.UpdatePageResponse.
 * Use `create(UpdatePageResponseSchema)` to create a new message.
 */
export const UpdatePageResponseSchema: GenMessage<UpdatePageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 30)

/**
 * @generated from message pages.v2.DeletePageRequest
 */
export type DeletePageRequest = Message<'pages.v2.DeletePageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message pages.v2.DeletePageRequest.
 * Use `create(DeletePageRequestSchema)` to create a new message.
 */
export const DeletePageRequestSchema: GenMessage<DeletePageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 31)

/**
 * @generated from message pages.v2.DeletePageResponse
 */
export type DeletePageResponse = Message<'pages.v2.DeletePageResponse'> & {}

/**
 * Describes the message pages.v2.DeletePageResponse.
 * Use `create(DeletePageResponseSchema)` to create a new message.
 */
export const DeletePageResponseSchema: GenMessage<DeletePageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 32)

/**
 * @generated from message pages.v2.LoadPageRequest
 */
export type LoadPageRequest = Message<'pages.v2.LoadPageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 2;
   */
  version: string
}

/**
 * Describes the message pages.v2.LoadPageRequest.
 * Use `create(LoadPageRequestSchema)` to create a new message.
 */
export const LoadPageRequestSchema: GenMessage<LoadPageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 33)

/**
 * @generated from message pages.v2.LoadPageResponse
 */
export type LoadPageResponse = Message<'pages.v2.LoadPageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.LoadPageResponse.
 * Use `create(LoadPageResponseSchema)` to create a new message.
 */
export const LoadPageResponseSchema: GenMessage<LoadPageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 34)

/**
 * @generated from message pages.v2.PreviewPageRequest
 */
export type PreviewPageRequest = Message<'pages.v2.PreviewPageRequest'> & {
  /**
   * @generated from field: string template_id = 1;
   */
  templateId: string

  /**
   * @generated from field: string template_version = 2;
   */
  templateVersion: string

  /**
   * @generated from field: google.protobuf.Struct config = 3;
   */
  config?: JsonObject
}

/**
 * Describes the message pages.v2.PreviewPageRequest.
 * Use `create(PreviewPageRequestSchema)` to create a new message.
 */
export const PreviewPageRequestSchema: GenMessage<PreviewPageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 35)

/**
 * @generated from message pages.v2.PreviewPageResponse
 */
export type PreviewPageResponse = Message<'pages.v2.PreviewPageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.PreviewPageResponse.
 * Use `create(PreviewPageResponseSchema)` to create a new message.
 */
export const PreviewPageResponseSchema: GenMessage<PreviewPageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 36)

/**
 * @generated from message pages.v2.SavePageRequest
 */
export type SavePageRequest = Message<'pages.v2.SavePageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 4;
   */
  version: string

  /**
   * @generated from field: google.protobuf.Struct config = 2;
   */
  config?: JsonObject

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject

  /**
   * @generated from field: bool validate_only = 5;
   */
  validateOnly: boolean
}

/**
 * Describes the message pages.v2.SavePageRequest.
 * Use `create(SavePageRequestSchema)` to create a new message.
 */
export const SavePageRequestSchema: GenMessage<SavePageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 37)

/**
 * @generated from message pages.v2.SavePageResponse
 */
export type SavePageResponse = Message<'pages.v2.SavePageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.SavePageResponse.
 * Use `create(SavePageResponseSchema)` to create a new message.
 */
export const SavePageResponseSchema: GenMessage<SavePageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 38)

/**
 * @generated from message pages.v2.PostPageRequest
 */
export type PostPageRequest = Message<'pages.v2.PostPageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 3;
   */
  version: string

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.PostPageRequest.
 * Use `create(PostPageRequestSchema)` to create a new message.
 */
export const PostPageRequestSchema: GenMessage<PostPageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 39)

/**
 * @generated from message pages.v2.PostPageResponse
 */
export type PostPageResponse = Message<'pages.v2.PostPageResponse'> & {
  /**
   * @generated from field: pages.v2.Page page = 1;
   */
  page?: Page

  /**
   * @generated from field: google.protobuf.Struct data = 2;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.PostPageResponse.
 * Use `create(PostPageResponseSchema)` to create a new message.
 */
export const PostPageResponseSchema: GenMessage<PostPageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 40)

/**
 * @generated from message pages.v2.ValidatePageRequest
 */
export type ValidatePageRequest = Message<'pages.v2.ValidatePageRequest'> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string

  /**
   * @generated from field: string version = 4;
   */
  version: string

  /**
   * @generated from field: google.protobuf.Struct config = 2;
   */
  config?: JsonObject

  /**
   * @generated from field: google.protobuf.Struct data = 3;
   */
  data?: JsonObject
}

/**
 * Describes the message pages.v2.ValidatePageRequest.
 * Use `create(ValidatePageRequestSchema)` to create a new message.
 */
export const ValidatePageRequestSchema: GenMessage<ValidatePageRequest> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 41)

/**
 * @generated from message pages.v2.ValidatePageResponse
 */
export type ValidatePageResponse = Message<'pages.v2.ValidatePageResponse'> & {}

/**
 * Describes the message pages.v2.ValidatePageResponse.
 * Use `create(ValidatePageResponseSchema)` to create a new message.
 */
export const ValidatePageResponseSchema: GenMessage<ValidatePageResponse> =
  /*@__PURE__*/
  messageDesc(file_pages_v2_page, 42)

/**
 * @generated from service pages.v2.PageService
 */
export const PageService: GenService<{
  /**
   * @generated from rpc pages.v2.PageService.CreateTemplate
   */
  createTemplate: {
    methodKind: 'unary'
    input: typeof CreateTemplateRequestSchema
    output: typeof CreateTemplateResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.CreateTemplateVersion
   */
  createTemplateVersion: {
    methodKind: 'unary'
    input: typeof CreateTemplateVersionRequestSchema
    output: typeof CreateTemplateVersionResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.PublishTemplateVersion
   */
  publishTemplateVersion: {
    methodKind: 'unary'
    input: typeof PublishTemplateVersionRequestSchema
    output: typeof PublishTemplateVersionResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.ListTemplates
   */
  listTemplates: {
    methodKind: 'unary'
    input: typeof ListTemplatesRequestSchema
    output: typeof ListTemplatesResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.GetTemplate
   */
  getTemplate: {
    methodKind: 'unary'
    input: typeof GetTemplateRequestSchema
    output: typeof GetTemplateResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.UpdateTemplate
   */
  updateTemplate: {
    methodKind: 'unary'
    input: typeof UpdateTemplateRequestSchema
    output: typeof UpdateTemplateResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.DeleteTemplate
   */
  deleteTemplate: {
    methodKind: 'unary'
    input: typeof DeleteTemplateRequestSchema
    output: typeof DeleteTemplateResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.CreatePageFromTemplate
   */
  createPageFromTemplate: {
    methodKind: 'unary'
    input: typeof CreatePageFromTemplateRequestSchema
    output: typeof CreatePageFromTemplateResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.CreatePage
   */
  createPage: {
    methodKind: 'unary'
    input: typeof CreatePageRequestSchema
    output: typeof CreatePageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.CreatePageVersion
   */
  createPageVersion: {
    methodKind: 'unary'
    input: typeof CreatePageVersionRequestSchema
    output: typeof CreatePageVersionResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.PublishPageVersion
   */
  publishPageVersion: {
    methodKind: 'unary'
    input: typeof PublishPageVersionRequestSchema
    output: typeof PublishPageVersionResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.ListPages
   */
  listPages: {
    methodKind: 'unary'
    input: typeof ListPagesRequestSchema
    output: typeof ListPagesResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.GetPage
   */
  getPage: {
    methodKind: 'unary'
    input: typeof GetPageRequestSchema
    output: typeof GetPageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.UpdatePage
   */
  updatePage: {
    methodKind: 'unary'
    input: typeof UpdatePageRequestSchema
    output: typeof UpdatePageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.DeletePage
   */
  deletePage: {
    methodKind: 'unary'
    input: typeof DeletePageRequestSchema
    output: typeof DeletePageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.LoadPage
   */
  loadPage: {
    methodKind: 'unary'
    input: typeof LoadPageRequestSchema
    output: typeof LoadPageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.PreviewPage
   */
  previewPage: {
    methodKind: 'unary'
    input: typeof PreviewPageRequestSchema
    output: typeof PreviewPageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.SavePage
   */
  savePage: {
    methodKind: 'unary'
    input: typeof SavePageRequestSchema
    output: typeof SavePageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.PostPage
   */
  postPage: {
    methodKind: 'unary'
    input: typeof PostPageRequestSchema
    output: typeof PostPageResponseSchema
  }
  /**
   * @generated from rpc pages.v2.PageService.ValidatePage
   */
  validatePage: {
    methodKind: 'unary'
    input: typeof ValidatePageRequestSchema
    output: typeof ValidatePageResponseSchema
  }
}> = /*@__PURE__*/ serviceDesc(file_pages_v2_page, 0)
